<script lang="ts">
  import { universityPricingPlans } from "./university_pricing_plans"
  import { Button } from "$lib/components/ui/button/index"
  import Card from "$lib/components/ui/card/Card.svelte"
  import { CheckCircle } from "lucide-svelte"

  export let callToAction = "Schedule a Consultation"
</script>

<div class="flex flex-col items-center mb-12">
  <div class="bg-base-200 p-6 rounded-lg mb-8 max-w-3xl mx-auto text-center">
    <h3 class="text-2xl font-bold mb-4">
      Partner with Ace The Round to Transform Your Finance Program
    </h3>
    <p class="text-lg text-base-content/80">
      Empower your students with AI-powered interview preparation and boost
      placement rates
    </p>
  </div>
</div>

<!-- University plans grid -->
<div class="grid md:grid-cols-3 gap-8 mb-20 max-w-6xl mx-auto px-4">
  {#each universityPricingPlans as plan}
    <div class="relative h-full flex flex-col">
      {#if plan.id === "advanced"}
        <div class="absolute -top-4 right-0 left-0 flex justify-center">
          <span
            class="bg-primary text-primary-content text-center py-1 px-4 rounded-full text-sm font-semibold"
          >
            Most Popular
          </span>
        </div>
      {/if}

      <Card
        className={`h-full flex flex-col ${plan.id === "advanced" ? "border-primary border-2 shadow-lg" : "border border-base-300 shadow-md"}`}
      >
        <div class="card-body h-full flex flex-col p-6">
          <div class="mb-6">
            <h3 class="card-title text-2xl font-bold">{plan.name}</h3>
            <p class="text-base-content/70 mt-2">{plan.description}</p>
          </div>

          <div class="mb-6">
            <p class="text-2xl font-bold">{plan.priceLabel}</p>
            {#if plan.highlightFeature}
              <div class="bg-base-200 p-4 rounded-md mt-4">
                <p class="font-medium text-sm">{plan.highlightFeature}</p>
              </div>
            {/if}
          </div>

          <div class="flex-grow">
            <ul class="space-y-4">
              {#each plan.features as feature}
                <li class="flex items-start gap-3">
                  <CheckCircle
                    class="w-5 h-5 text-success flex-shrink-0 mt-0.5"
                  />
                  <span>{feature}</span>
                </li>
              {/each}
            </ul>
          </div>

          <div class="mt-6 pt-4 border-t border-base-200">
            <Button
              href="/contact_us"
              class={`w-full h-14 px-6 text-base font-medium flex items-center justify-center bg-primary hover:bg-primary-focus text-primary-content`}
            >
              {plan.ctaText || callToAction}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  {/each}
</div>
